"use client";

import Image from "next/image";
import { Heading } from "@/components/ui/typography";
import Link from "next/link";

export default function WireframeSection({ heading = "The Foundation of Your Global Tax Strategy" }: { heading?: string } = {}) {
  return (
    <section className="relative w-full bg-black min-[1340px]:px-0 px-4 py-[60px]">
      {/* LEFT IMAGE */}
      <div className="max-w-[1200px] flex mx-auto items-center gap-[32px]">
        <div className="  hidden lg:block">
          <Image
            src="/freepic.webp"
            alt="visual"
            width={583}
            height={595}
            //   className="object-cover"
          />
        </div>

        {/* RIGHT TOP CONTENT */}
        <div className=" flex flex-col gap-8 w-[584px]">
          <div className="flex flex-col gap-6">
            <Heading as="h2" variant="section">
              {heading}
            </Heading>

            <p className="text-[16px] md:text-[18px] leading-[160%] text-white/60 font-medium font-inter">
              Hong Kong operates on a territorial basis of taxation. This means
              that profits derived from outside Hong Kong are potentially exempt
              from Hong Kong corporate tax.
            </p>

            {/* BOXES */}
            <div className="bg-[#0f1218] border-l-2 border-white px-6 py-3 flex flex-col gap-4">
              <p className="p-[16px] md:text-[18px] leading-[150%] font-inter text-white">
                If profits are generated{" "}
                <span className="font-bold">inside Hong Kong</span> → taxable
              </p>

              <p className="p-[16px] md:text-[18px] leading-[150%] font-inter text-white">
                If profits are generated{" "}
                <span className="font-bold">outside Hong Kong</span> →
                potentially 0% tax
              </p>
            </div>

            <p className="text-[16px] md:text-[18px] leading-[160%] text-white/60 font-medium font-inter">
              This is how international founders legally reduce corporate tax
              exposure using a{" "}
              <Link
                className="hover:underline"
                href="/hong-kong-company-formation"
              >
                Hong Kong company
              </Link>
              .
            </p>
          </div>

          <Link
            href="https://www.ird.gov.hk/eng/welcome.htm"
            className="text-[#335cff] text-[16px] font-medium font-inter"
          >
            ↗ Hong Kong Inland Revenue Department
          </Link>
        </div>
      </div>

      {/* BOTTOM CARDS */}
      <div className=" max-w-[1200px] mx-auto flex flex-col gap-8 mt-[18px]">
        <div className="flex flex-col lg:flex-row gap-8">
          {/* CARD 1 */}
          <div className="flex-1 bg-[#0f1218] rounded-[16px] p-8 md:p-12 flex flex-col gap-6">
            <div className="flex items-center gap-4">
              <Image
                src="/founder-a.webp"
                alt="Founder"
                width={56}
                height={56}
                className="rounded-lg"
              />
              <p className="text-sm text-white/60 font-inter">Founder A</p>
            </div>

            <p className="text-[18px] md:text-[24px] leading-[160%] text-white font-inter">
              Sells products to customers{" "}
              <span className="font-bold">inside Hong Kong</span>. Those profits
              are taxable.
            </p>
          </div>

          {/* CENTER TEXT */}
          <div className="flex-1 flex flex-col items-center justify-center text-center text-[18px] leading-[160%] text-white font-inter">
            That difference determines whether profits are taxed. Not company
            location. Not citizenship. Not nationality. <br />
            <span className="font-medium">Profit source location.</span>
          </div>

          {/* CARD 2 */}
          <div className="flex-1 bg-[#0f1218] border-2 border-[#005c00] rounded-[16px] p-8 md:p-12 flex flex-col gap-6">
            <div className="flex items-center gap-4">
              <Image
                src="/founder-a.webp"
                alt="Founder"
                width={56}
                height={56}
                className="rounded-lg"
              />
              <p className="text-sm text-white/60 font-inter">Founder B</p>
            </div>

            <p className="text-[18px] md:text-[24px] leading-[160%] text-white font-inter">
              Runs an eCommerce brand selling to the US, UK, and Europe while
              operating remotely. Those profits may qualify as offshore profits.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
